import { v4 as uuidv4 } from 'uuid';
// Global counter to ensure uniqueness even when Date.now() returns the same value
let globalNodeCounter = 0;
/**
 * Generate a unique node ID.
 */
export function generateNodeId(type, index) {
    return `${type}_${Date.now()}_${index}_${globalNodeCounter++}`;
}
/**
 * Generate a unique graph ID.
 */
export function generateGraphId() {
    return uuidv4();
}
/**
 * Generate a unique edge ID.
 */
export function generateEdgeId(source, target) {
    return `e-${source}-${target}-${Date.now()}`;
}
/**
 * Reset the global counter (for testing purposes)
 */
export function resetNodeCounter() {
    globalNodeCounter = 0;
}
//# sourceMappingURL=generateIds.js.map